/**
 * A /link-c link id: a cuid2 today, with room for older ids. The page, the
 * Join action, and the sign-in return path all check ids against this rule,
 * so an id that renders can also be joined and returned to.
 */
export const partnerLinkIdPattern = "[a-zA-Z0-9]{10,64}";

export const partnerLinkIdRegex = new RegExp(`^${partnerLinkIdPattern}$`);
